import { message, notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'

export const onDeleteUser = ({
  form,
  deleteUser,
  setIsSaving,
  onRefetch,
  onClose,
  sendUserDataToGTM,
}) => {
  form
    .validateFields()
    .then((values) => {
      setIsSaving(true)
      deleteUser(values)
        .then(() =>
          onRefetch().then(() => {
            message.success(i18n.t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
            onClose()
            sendUserDataToGTM()
          }),
        )
        .catch((error) => {
          notification.error({
            message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error, 'FEEDBACK_DELETE_FAIL'),
            duration: 0,
          })
          onClose()
        })
    })
    .catch((e) => {})
}
